import { Component, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from "@angular/router";

@Component({
  selector: 'go-back-button',
  templateUrl: './go-back-button.component.html',
  styleUrls: ['./go-back-button.component.scss']
})
export class GoBackButtonComponent {

  @Input() url?: string;
  constructor(
    private _location: Location,
    private _router: Router
  ) {}

  goBack() {
    this.url ? void this._router.navigate([this.url]) : this._location.back();
  }
}
